<template>
  <div>
    <v-container>
      <v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<style>

</style>

<script>
export default {

}
</script>
